export const BREAKPOINT = {
  PHONE: 'phone',
  TABLET: 'tablet',
  SMALL_SCREEN: 'smallScreen',
  MEDIUM_SCREEN: 'mediumScreen',
  LARGE_SCREEN: 'largeScreen',
} as const

export type BREAKPOINT = (typeof BREAKPOINT)[keyof typeof BREAKPOINT]

const breakpointValues = {
  [BREAKPOINT.PHONE]: {
    MIN: 0,
    MAX: 480,
  },
  [BREAKPOINT.TABLET]: {
    MIN: 481,
    MAX: 768,
  },
  [BREAKPOINT.SMALL_SCREEN]: {
    MIN: 769,
    MAX: 1024,
  },
  [BREAKPOINT.MEDIUM_SCREEN]: {
    MIN: 1025,
    MAX: 1200,
  },
  [BREAKPOINT.LARGE_SCREEN]: {
    MIN: 1201,
    MAX: 99999,
  },
}

export function getBreakpoint(width: number) {
  for (const breakpoint of Object.values(BREAKPOINT)) {
    if (
      width <= getBreakpointMax(breakpoint) &&
      width >= getBreakpointMin(breakpoint)
    ) {
      return breakpoint
    }
  }
  return BREAKPOINT.MEDIUM_SCREEN
}

export function getBreakpointMax(breakpoint: BREAKPOINT): number {
  return breakpointValues[breakpoint]?.MAX ?? 0
}

export function getBreakpointMin(breakpoint: BREAKPOINT): number {
  return breakpointValues[breakpoint]?.MIN ?? 0
}
